<template>
  <div>
    <v-toolbar flat class="mb-5">
      <v-btn
        class="mr-4 rounded-lg"
        color="success"
        @click="showOutsourceModal()"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Start New
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="!autoUploadTriggered"
        class="mr-4 rounded-lg"
        @click="triggerAutoUpload()"
      >
        <v-icon class="mr-2">mdi-cloud-upload</v-icon>
        Auto Upload
      </v-btn>
      <v-btn v-if="autoUploadTriggered" class="mr-4 rounded-lg" color="success">
        <v-icon class="mr-2">mdi-check</v-icon>
        Auto Upload
      </v-btn>
    </v-toolbar>
    <v-row>
      <v-col sm="12" lg="4">
        <OutsourceSharedFiles class="mb-5" />
        <OutsourceReceivedFiles />
      </v-col>
      <v-col
        sm="12"
        lg="4"
        v-for="outsource in kase.outsources"
        :key="outsource.id"
      >
        <PreemptiveJobCard v-if="!outsource.start" :outsource="outsource" />
        <JobCard v-if="outsource.start" :outsource="outsource" />
      </v-col>
    </v-row>
    <BulkOutsourceModal
      v-model="displayBulkOutsourceModal"
      :prefilled-main-case="currentCase"
      :prefilled-additional-cases="groupedCases"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import JobCard from "./Outsource/JobCard";
import PreemptiveJobCard from "./Outsource/PreemptiveJobCard";
import BulkOutsourceModal from "@/collection/components/shared/BulkOutsourceModal";
import OutsourceSharedFiles from "@/collection/components/ComponentDrawer/Files/OutsourceSharedFiles";
import OutsourceReceivedFiles from "@/collection/components/ComponentDrawer/Files/OutsourceReceivedFiles";

export default {
  name: "Outsource",
  components: {
    JobCard,
    PreemptiveJobCard,
    BulkOutsourceModal,
    OutsourceSharedFiles,
    OutsourceReceivedFiles
  },
  data() {
    return {
      autoUploadTriggered: false,
      displayBulkOutsourceModal: false
    };
  },
  computed: {
    ...mapGetters(["kase", "collection"]),
    currentCase() {
      if (!this.kase || !this.collection.cases) {
        return null;
      }
      return this.collection.cases.find(c => c.case_id === this.kase.case_id);
    },
    groupedCases() {
      if (!this.kase || !this.kase.group_number || !this.collection.cases) {
        return [];
      }
      return this.collection.cases.filter(related => {
        return (
          related.group_number === this.kase.group_number &&
          related.uid !== this.kase.uid
        );
      });
    }
  },
  methods: {
    ...mapActions(["startLoading", "stopLoading"]),
    showOutsourceModal() {
      this.displayBulkOutsourceModal = true;
    },
    async triggerAutoUpload() {
      this.startLoading();
      this.$axios
        .post(`/api/v2/case/${this.kase.case_id}/`, {
          action: "auto_outsource_upload"
        })
        .then(() => {
          this.autoUploadTriggered = true;
          this.stopLoading();
        });
    }
  }
};
</script>
